import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const PropertyModal = ({ open, onClose, data }) => {
  if (!data) return null;

  const Row = ({ label, value }) => (
    <Typography sx={{ mb: 1 }}>
      <strong>{label}:</strong> {value ?? "-"}
    </Typography>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Property Details
      </DialogTitle>

      <DialogContent dividers>
        <Box>
          <Row 
            label="Name" 
            value={data.user_first_name && data.user_last_name 
              ? `${data.user_first_name} ${data.user_last_name}` 
              : data.username || "-"} 
          />
          <Row 
            label="Mobile" 
            value={data.user_mobile_no || data.mobile_no || "-"} 
          />
          <Row label="Type" value={data.type} />
          <Row label="Property Type" value={data.property_type} />
          <Row label="Posted By" value={data.posted_by} />
          <Row label="Location" value={data.location} />
          <Row label="Latitude" value={data.lat} />
          <Row label="Longitude" value={data.long} />
          <Row label="Facing" value={data.facing} />
          <Row label="Road Width" value={data.roadwidth} />
          <Row label="Min Acres" value={data.min_acres} />
          <Row label="Max Acres" value={data.max_acres} />
          <Row label="Ratio" value={data.ratio} />
          <Row label="Floor" value={data.floor} />
          <Row
            label="Budget"
            value={`₹${data.min_budget?.toLocaleString()} - ₹${data.max_budget?.toLocaleString()}`}
          />
          <Row label="Description" value={data.description} />
          <Row
            label="Created At"
            value={new Date(data.created_at).toLocaleString()}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PropertyModal;